import React, { useState, useEffect } from 'react';
import '../css/Countdown.css';

// Move this outside the component
const calculateTimeLeft = (targetDate) => {
  const difference = +new Date(targetDate) - +new Date();
  let timeLeft = {};

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
    };
  }

  return timeLeft;
};

function Countdown({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(targetDate));
    }, 60000); // updates every minute

    return () => clearInterval(timer);
  }, [targetDate]); // now safe to include dependencies

  return (
    <div className="countdown">
      <h3 className="countdown-title">Launching in:</h3>
      <div className="countdown-grid">
        <div className="countdown-box">
          <span className="countdown-number">{timeLeft.days || 0}</span>
          <span className="countdown-label">Days</span>
        </div>
        <div className="countdown-box">
          <span className="countdown-number">{timeLeft.hours || 0}</span>
          <span className="countdown-label">Hours</span>
        </div>
        <div className="countdown-box">
          <span className="countdown-number">{timeLeft.minutes || 0}</span>
          <span className="countdown-label">Minutes</span>
        </div>
      </div>
    </div>
  );
}

export default Countdown;
